import { type PreferenceSchema, prefs } from './registry';

export function getPref<K extends keyof PreferenceSchema>(key: K): PreferenceSchema[K] {
    return prefs[key].get() as PreferenceSchema[K];
}

export function setPref<K extends keyof PreferenceSchema>(key: K, value: PreferenceSchema[K]): void {
    // biome-ignore lint/suspicious/noExplicitAny: dynamic dispatch across heterogeneous prefs
    (prefs[key] as { set: (v: any) => void }).set(value);
}
